import type { Prisma } from "@prisma/client";
import { participantWithSubmissionFilesSelect } from "../participants/participant.vars";
import { constructionSiteFullDetailsSelector } from "./constructionSites.vars";
import { selectedBinderWarrantySelector } from "./constructionSitesOffers.vars";
import { basicFileSelector } from "../files/files.vars";

export const submissionAbilityControlSelect = {
  constructionSite: {
    select: {
      brokerSocietyId: true,
      status: true,
    }
  }
} satisfies Prisma.ConstructionSiteSubmissionSelect

export const constructionSiteSubmissionSelector = {
	id: true,
	constructionSiteId: true,
	createdAt: true,
	updatedAt: true,
	administrativeAuthorizationType: true,
	constructionSite: {
		select: {
			id: true,
			brokerSocietyId: true,
		},
	},
	folder: {
		select: {
			id: true,
			files: {
				select: {
					id: true,
					key: true,
					name: true,
					size: true,
					createdAt: true,
				},
			},
		},
	},
	selectedBinderWarranties: {
		select: selectedBinderWarrantySelector,
	},
} satisfies Prisma.ConstructionSiteSubmissionSelect;

export const administrativeAuthorizationTypes = [
  "NO_NEED",
  "PERMIS_CONSTRUIRE",
  "DECLARATION_PREALABLE",
] as const
export const administrativeAuthorizationTypeToLabel = {
  NO_NEED: "Sans besoin d'autorisation",
  PERMIS_CONSTRUIRE: "Permis de construire",
  DECLARATION_PREALABLE: "Déclaration préalable de travaux",
} as const

export const submissionWithOperationDetailsSelect = {
  administrativeAuthorizationType: true,
  authorizationReference: true,
  coOwnersSyndicDenomination: true,
  operationDescription: true,
  constructionSite: {
    select: constructionSiteFullDetailsSelector
  },
  filesOnConstructionSiteSubmissions: {
    select: {
      type: true,
      file: {
        select: basicFileSelector
      }
    }
  }
} satisfies Prisma.ConstructionSiteSubmissionSelect;

export const submissionWithParticipantsSelect = (constructionSiteSubmissionId: number) => ({
  constructionSite: {
    select: {
      status: true,
    }
  },
  participantToConstructionSiteSubmissions: {
    select: {
      id: true,
      type: true,
      designerType: true,
      totalFeesTTC: true,
      totalFeesHT: true,
      totalMissionsOrActivitiesOrMaterialTypes: true,
      participant: {
        select: participantWithSubmissionFilesSelect(constructionSiteSubmissionId)
      }
    }
  }
} satisfies Prisma.ConstructionSiteSubmissionSelect)

export const quoteOrFeeAgreementFeesAndMissionsSelect = (constructionSiteId: number) =>  ({
  feesHT: true,
  feesTTC: true,
  invoiceAmount: true,
  filesOnConstructionSiteSubmission: {
    select: {
      type: true,
    },
    where: {
      constructionSiteSubmission: {
        constructionSiteId: constructionSiteId,
      }
    }
  },
  filesOnConstructionSiteReception: {
    select: {
      type: true
    },
    where: {
      constructionSiteId: constructionSiteId,
    }
  },
  missionsOrActivitiesOrMaterialTypes: true,
} satisfies Prisma.QuoteOrFeeAgreementDetailsSelect)

export const participantToConstructionSiteSubmissionSelect = (constructionSiteSubmissionId: number) => ({
  id: true,
  type: true,
  designerType: true,
  totalFeesTTC: true,
  totalFeesHT: true,
  totalMissionsOrActivitiesOrMaterialTypes: true,
  participant: {
    select: participantWithSubmissionFilesSelect(constructionSiteSubmissionId)
  }
} satisfies Prisma.ParticipantToConstructionSiteSubmissionSelect)

export const submissionWithBinderWarrantiesSelectedSelect = {
  id: true,
  selectedBinderWarranties: {
    select: selectedBinderWarrantySelector,
  },
} satisfies Prisma.ConstructionSiteSubmissionSelect
